import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";
import { trackingHeaders } from "../helpers";

export interface MisdeliveryAuditPayload {
  didSaiaRecoverMisdelvFreight?: string;
  didSaiaRecoverMisdelvFreightWhy?: string;
  notRecoveredFreightStatementOrDrImaged?: string;
  recoveredFreightNewProNumber?: number;
  recoveredFreightSaiaMisdelvBol?: string;
  saiaMisdelvBolConfirmBilling?: string;
  saiaMisdelvBolConfirmBillingDetail?: string;
  saiaMisdelvBolConfirmImaged?: string;
  saiaMisdelvBolConfirmImagedDetail?: string;
  recoveredFreightCustomerProvidedBol?: string;
  customerProvidedBolConfirmBilling?: string;
  customerProvidedBolConfirmBillingDetail?: string;
  customerProvidedBolConfirmImaged?: string;
  customerProvidedBolConfirmImagedDetail?: string;
  recoveredFreightNewProAllShort?: string;
  recoveredFreightNewProShowsProOrNbOv?: string;
  newProShowsProOrNbOvDetail?: string;
  recoveredFreightConfirmDrImaged?: string;
  drImagedSignedShowingAppliesToProOrNbOv?: string;
  signedAppliesToProOrNbOvExceptionNumber?: string;
  didMisdelvPickupLeaveConsigneeShort?: string;
  misdelvPickupConsigneeShortAdditionalComments?: string;
  didRepresentativeUpdateDeliveryStatus?: string;
  representativeDeliveryStatusAdditionalComments?: string;
  didMisdelvFreightMoveCorrectly?: string;
  misdelvFreightMoveOriginalPro?: string;
  misdelvFreightMoveSuffixPro?: string;
  correctConsigneeReceivedCompleteOrder?: string;
  correctConsigneeOrderDoesDeliveryStatusShowOpenShortage?: string;
  misdelvFreightMoveCorrectlyAdditionalComments?: string;
  recoveredFreightConfirmOption14?: string;
  recoveredFreightConfirmF18NotesClosingStatement?: string;
  recoveredFreightMsdExceptionAppliesToPro?: string;
}

export type MisdeliveryAuditAction = "save" | "complete";

export const saveMisdeliveryAudit = async (
  osdNumber: string | number,
  action: MisdeliveryAuditAction,
  payload: MisdeliveryAuditPayload
) => {
  try {
    const osdNumberStr = (osdNumber ?? "").toString().trim();
    const url = getUrl(ApiType.MISDELIVERY_AUDIT)
      .replace(":osdNumber", encodeURIComponent(osdNumberStr))
      .replace(":action", encodeURIComponent(action));

    const headers = trackingHeaders({
      moduleName: "misdelivery",
      sectionName: "audit",
      osdType: "MSD",
      actionType: action === 'complete' ? "submit" : action,
      osdNumber: osdNumberStr,
    });

    const { data } = await axios.post(url, payload, { headers });
    return data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.misdeliveryAuditError, {
      badRequestOrder: "errorsFirst",
    });
  }
};
